<template>
	<div class="row quotes-testimonials" data-aos="fade-up">
		<div class="col-full">
			<div class="testimonials">
				<template v-for="quote in quotes">
					<div class="testimonials__slide">
						<p v-html="$t('texts.' + quote[0])"></p>

						<img v-bind="{src: quote[2], alt: quote[1]}" class="testimonials__avatar">
						<div class="testimonials__info">
							<span class="testimonials__name">{{ quote[1] }}</span>
							<!--<span class="testimonials__pos">CEO, Apple</span>-->
						</div>
					</div>
				</template>
			</div>
		</div>
	</div>
</template>

<script>
	// import params
	import {params as SiteParams} from '../../params';

	// export
	export default {
		name: 'WidgetQuotes',
		data: function () {
			return {
				quotes: SiteParams['quotes']
			}
		},
	}
</script>


// WEBPACK FOOTER //
// src/components/widgets/Quotes.vue